export class Question {
    constructor(
        public Code:string,
        public Text: string,
        public AnswerType: string,
        public Mandatory: string,
        public Scale: string,
        public Precision: string,
        public Length: string,
        public SequenceNumber: string,
        public Answer: Answer | AnswerOption2,
        public Applicable: string,
        public ReEvaulateOnChange: string,
        public ChannelDisabled: string,
        public PreConditions:PreConditions[] | null
    ){

    }
}

export class Answer {
    constructor(
        public Answer: string 
    ){}
}

export class AnswerOption2 {
    constructor(
        public Answers: MultipleOption[],
        public Answer:MultipleOption
    ){}
}

export class MultipleOption {
    constructor(
        public Code: string,
        public Text: string,
        public SequenceNumber: string | number
    ){}
}

class PreConditions {
    constructor(
        public PreConditionType: string,
        public QuestionCode: string,
        public AnswerCode: string,
        public ParameterCode: string,
        public ParameterValue: string
    ){}
}

export class FAQS {
    constructor(
        public Category: string,
        public IconActive: string,
        public IconInactive: string,
        public Questions: FAQSQuestions []
    ){}
}
export class FAQSQuestions{
    constructor(
        public Position: string,
        public Question: string,
        public Answer: string
    ){}
}